export default __webpack_public_path__ + "assets/logoSnapcodePreviewExample.d560db.png";